import { Link } from 'react-router-dom';

interface BlogHeroProps {
  title: string;
  breadcrumbs: { label: string; href?: string }[];
}

export default function BlogHero({ title, breadcrumbs }: BlogHeroProps) {
  return (
    <section className="relative w-full overflow-hidden" style={{ minHeight: '380px' }}>
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20modern%20healthcare%20blog%20header%20abstract%20flowing%20organic%20shapes%20in%20warm%20earthy%20terracotta%20beige%20cream%20tones%20soft%20gradient%20subtle%20medical%20cross%20silhouette%20editorial%20quality%20artistic%20background&width=1920&height=500&seq=blog-hero-bg-v1&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-center"
          width={1920}
          height={500}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 via-gray-900/70 to-gray-900/60" />
      </div>

      <div
        className="relative z-10 max-w-7xl mx-auto px-6 flex flex-col justify-center"
        style={{ minHeight: '380px', paddingTop: '128px', paddingBottom: '48px' }}
      >
        {/* Breadcrumbs with icon style */}
        <nav aria-label="Breadcrumb" className="mb-6">
          <ol className="flex items-center flex-wrap gap-2 text-sm">
            {(breadcrumbs || []).map((crumb, idx) => (
              <li key={crumb.label} className="flex items-center">
                {idx > 0 && (
                  <span className="mx-2 text-white/30" aria-hidden="true">
                    <i className="ri-arrow-right-s-line text-white/50"></i>
                  </span>
                )}
                {crumb.href ? (
                  <Link to={crumb.href} className="flex items-center gap-1.5 text-white/70 hover:text-white transition-colors">
                    {idx === 0 && <i className="ri-home-4-line text-sm"></i>}
                    <span>{crumb.label}</span>
                  </Link>
                ) : (
                  <span className="flex items-center gap-1.5 text-accent-400 font-medium">
                    <i className="ri-bookmark-line text-sm"></i>
                    <span>{crumb.label}</span>
                  </span>
                )}
              </li>
            ))}
          </ol>
        </nav>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl">
          {title}
        </h1>
      </div>
    </section>
  );
}